import { render, staticRenderFns } from "./managementDetailsGifts.vue?vue&type=template&id=8699bf36"
import script from "./managementDetailsGifts.vue?vue&type=script&lang=js"
export * from "./managementDetailsGifts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports